import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bt_login" }
const _hoisted_2 = {
  key: 0,
  class: "consent_content"
}
const _hoisted_3 = { class: "check_box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" By clicking ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" , you agree to the storing of cookies, Terms&Conditions and Privacy Policy. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["WelcomeBox", {'f30':!_ctx.IsShowConsent}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["bt", {'active':_ctx.checked}]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.StartTarot && _ctx.StartTarot(...args)))
      }, "เริ่มคำทำนาย", 2)
    ]),
    (_ctx.IsShowConsent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_checkbox, {
              checked: _ctx.checked,
              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checked) = $event)),
              class: "checkbox"
            }, null, 8, ["checked"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["consent_detail", {'warn':_ctx.IsError}])
            }, [
              _hoisted_4,
              _createElementVNode("span", {
                class: "under_line",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ShowPopupCookie && _ctx.ShowPopupCookie(...args)))
              }, "“Accept Cookies”"),
              _hoisted_5,
              _createElementVNode("span", {
                class: "under_line",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.ShowPopupCookie && _ctx.ShowPopupCookie(...args)))
              }, "“Terms&Conditions”"),
              _hoisted_6,
              _createElementVNode("span", {
                class: "under_line",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.ShowPopupCookie && _ctx.ShowPopupCookie(...args)))
              }, "“Privacy Policy”"),
              _hoisted_7
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}